import { toApiException } from '@shared/helpers/toApiException';
import { SUPPORT_NOTIFIED_MESSAGE } from '@shared/i18n';

import { AI_CONNECTION_LOST_MESSAGE } from '../constants';
import isConnectionError from './isConnectionError.helper';

const toAiErrorMessage = (error: unknown): string =>
  toApiException(error)?.message || (isConnectionError(error) ? AI_CONNECTION_LOST_MESSAGE : SUPPORT_NOTIFIED_MESSAGE);

export default toAiErrorMessage;
